// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1uJMa","form":"styles_form__2exay"};